module.exports = __webpack_public_path__ + "img/Storytelling.ab2fe25a.jpg";